import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'app-dynamic-son-list-two-columns',
  templateUrl: './dynamic-son-list-two-columns.component.html',
  styleUrls: ['./dynamic-son-list-two-columns.component.scss']
})
export class DynamicSonListTwoColumnsComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() mySonListName: string;
  @Input() itemList;
  @Input() mylabel: string;
  @Input() captions: string[];
  @Input() view:boolean;
  counter = 0;
  constructor() { }

  ngOnInit() {
  }

  get addFlexListElement() {
    return this.parentForm.get(this.mySonListName) as FormArray
  }

  addItem(value?) {
    if (value) {
      let kk = new FormGroup({});
      kk.addControl(this.captions[0], new FormControl(value[0]));
      kk.addControl(this.captions[1], new FormControl(value[1]));
      
      this.addFlexListElement.push(kk);
    }
    else {
      let kk = new FormGroup({});
      kk.addControl(this.captions[0], new FormControl(''));
      kk.addControl(this.captions[1], new FormControl(''));
      
      this.addFlexListElement.push(kk);
    }
  }

  removeItem(index:number) {
         this.addFlexListElement.removeAt(index);
   
  }

  isEmail(caption:string)
  {
    if(caption.toLowerCase().includes("email")){ 
      
      return true;}
    return false;
  }

}
